import React from 'react';
import { useParams } from 'react-router-dom';
import ProductDetailsDashboard from '../ProductDetailsDashboard';
import { AdminUser } from '../../../../types/admin-v2';
import { getDynamicSubItems } from '../../../../utils/getDynamicSubItems';
import CompanySubNavigation from '../../../common/CompanySubNavigation';

interface CompanyProductDetailsDashboardProps {
  user: AdminUser;
  currentRoute: string;
  onNavigate: (route: string) => void;
  onLogout: () => void;
}

const CompanyProductDetailsDashboard: React.FC<CompanyProductDetailsDashboardProps> = ({
  user,
  currentRoute,
  onNavigate,
  onLogout
}) => {
  const { companyId } = useParams<{ companyId: string }>();



  // Only show secondary sidebar for admin users, not for regular users
  const isAdmin = user.role === 'admin';

  return (
    <ProductDetailsDashboard
      user={user}
      currentRoute={currentRoute}
      onNavigate={onNavigate}
      onLogout={onLogout}
      companyId={companyId}
      layoutType={isAdmin ? 'admin' : 'user'}
      getDynamicSubItems={getDynamicSubItems}
      navigationActions={
        isAdmin ? (
          <CompanySubNavigation
            currentRoute={currentRoute}
            onNavigate={onNavigate}
            isAdmin={isAdmin}
          />
        ) : undefined
      }
    />
  );
};

export default CompanyProductDetailsDashboard;





